class BandCupSelector {
    constructor(sizeSelector, bandCupSelectors, buyButtons) {
        this.sizeSelector = document.querySelector(sizeSelector);
        if (!this.sizeSelector) return;

        const parentElementSizeSelector = this.sizeSelector.closest('variant-picker');
        if (!parentElementSizeSelector) return;

        this.bandCupSelectors = parentElementSizeSelector.querySelector(bandCupSelectors);
        if (!this.bandCupSelectors) return;
        
        this.bandDropdown = this.bandCupSelectors.querySelector("select#band");
        this.cupDropdown = this.bandCupSelectors.querySelector("select#cup");
        this.buyButtons = document.querySelector(buyButtons);
        this.addToCart = this.buyButtons?.querySelector("button[type='submit']");
        this.fakeOptionsSelector = this.bandCupSelectors.querySelectorAll('div[class^="fake-options"]');
        this.soldOutVariants = this.bandCupSelectors.getAttribute('data-sold-out-variants');
        this.isDesktop = window.matchMedia("(min-width: 768px)").matches;
        this.BisButton = this.buyButtons?.parentElement.querySelector("#BIS_trigger");
        this.soldOutVariant = '';

        this.init();
    }

    init() {
        this.setupEventListeners();
        this.setupFakeOptions();
        this.initMarkupObject();
        this.handleOutsideClick();
        this.handleUrlVariant();
    }

    handleUrlVariant() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        
        // Try filtered sizes from quickbuy
        if (window._qbSizes) {
            for (const size of window._qbSizes) {
                const match = size.match(/^(\d+)([A-Z]+)$/);
                if (match) {
                    const [, band, cup] = match;
                    const combinedSize = band + cup;
                    const sizeOption = this.sizeSelector?.querySelector(`[value="${combinedSize}"]`);
                    
                    if (sizeOption && !this.soldOutVariant?.includes(combinedSize)) {
                        this.autoSelectVariant({ band, cup, combinedSize }, false);
                        window._qbSizes = null;
                        return;
                    }
                }
            }
            window._qbSizes = null;
        }
        
        if (variantId && this.variantObj) {
            this.selectVariantById(variantId);
        }
    }

    selectVariantById(variantId) {
        let foundVariant = null;
        
        for (const bandCupPair of this.variantObj) {
            for (const band in bandCupPair) {
                const cups = bandCupPair[band];
                for (const cup of cups) {
                    const combinedSize = band + cup;
              
                    const sizeOption = this.sizeSelector.querySelector(`[value="${combinedSize}"]`);
                    if (sizeOption && sizeOption.dataset.variant === variantId) {
                        foundVariant = { band, cup, combinedSize };
                        break;
                    }
                }
                if (foundVariant) break;
            }
            if (foundVariant) break;
        }

        if (foundVariant) {
            const isSoldOut = this.soldOutVariant.includes(foundVariant?.combinedSize);
            this.autoSelectVariant(foundVariant, isSoldOut);
        }
    }

    autoSelectVariant(variant, isSoldOut) {
        const { band, cup, combinedSize } = variant;
        
        // Set band dropdown
        if (this.bandDropdown) {
            this.bandDropdown.value = band;
            this.populateCupOptions(band);
            
            this.updateFakeOptionsSelection(this.bandDropdown, band);
        }
        
        setTimeout(() => {
            if (this.cupDropdown) {
                this.cupDropdown.value = cup;
                this.cupDropdown.classList.toggle('sold-out-option', 
                this.soldOutVariant.includes(combinedSize));
                
                if(isSoldOut) {
                    if(this.BisButton) {
                        this.BisButton.classList.add('should-show');
                    }
                }

                this.updateFakeOptionsSelection(this.cupDropdown, cup);
                
                this.cupDropdown.dispatchEvent(new Event('change', { 'bubbles': true }));
            }
            
            this.selectSizeOption(combinedSize);
            this.removePreSelectionText();
            
        }, 100);
    }

    updateFakeOptionsSelection(select, value) {
        const fakeOptions = this.bandCupSelectors.querySelector(`.fake-options--${select.id}`);
        if (fakeOptions) {
            const buttons = fakeOptions.querySelectorAll('button');
            buttons.forEach(button => {
                const isSelected = button.dataset.option === value;
                button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
                if (isSelected) {
                    button.classList.add('selected');
                }
            });
        }
    }


    selectSizeOption(combinedSize) {
        if (this.sizeSelector.hasAttribute('is-dropdown')) {
            this.sizeSelector.querySelectorAll('button[role="option"]').forEach(button => {
                const buttonValue = button.getAttribute('value');
                if (combinedSize === buttonValue) {
                    button.dispatchEvent(new Event("click", { bubbles: true }));
                }
            });
        } else {
            this.sizeSelector.querySelectorAll('input[name^="option"]').forEach(option => {
                if (combinedSize === option.value) {
                    option.checked = true;
                    option.dispatchEvent(new Event("change", { bubbles: true }));
                }
            });
        }
    }

    removePreSelectionText() {
        if (this.bandDropdown) {
            const firstBandOption = this.bandDropdown.querySelector('option[value=""]');
            if (firstBandOption && (firstBandOption.textContent.toLowerCase().includes('choose') || 
                                  firstBandOption.textContent.toLowerCase().includes('select'))) {
                firstBandOption.remove();
            }
        }
        
        if (this.cupDropdown) {
            const firstCupOption = this.cupDropdown.querySelector('option[value=""]');
            if (firstCupOption && (firstCupOption.textContent.toLowerCase().includes('choose') || 
                                 firstCupOption.textContent.toLowerCase().includes('select'))) {
                firstCupOption.remove();
            }
        }
    }

    setupEventListeners() {
        this.bandCupSelectors.querySelectorAll('select').forEach(select => {
            select.parentElement.addEventListener('click', (e) => this.handleSelectClick(e, select));
            this.updateAriaControls(select);

            const observer = new MutationObserver(() => {
                this.updateAriaControls(select);
            });
            observer.observe(select, { attributes: true, attributeFilter: ['disabled'] })
        });
    }

    updateAriaControls(select) {
        if (this.isDesktop || select.disabled) {
            select.parentElement.removeAttribute('aria-controls');
        } else {
            select.parentElement.setAttribute('aria-controls', `${select.id}-modal`);
        }
    }


    handleSelectClick(e, select) {
        if (select.disabled === true ) return;
        const fakeOptions = this.bandCupSelectors.querySelector(`.fake-options--${select.id}.desktop`);
        if (this.isDesktop) {
            this.fakeOptionsSelector.forEach(fakoption => {
                if (fakoption !== fakeOptions && fakoption.classList.contains('desktop')) {
                    fakoption.style.display = 'none';
                }
            });
            fakeOptions.style.display = fakeOptions.style.display === "none" ? "block" : "none";
            e.stopPropagation();
        }
    }

    handleOutsideClick() {
        document.addEventListener('click', (event) => {
            this.fakeOptionsSelector.forEach(fakoption => {
                if (fakoption.classList.contains('desktop')) {
                    const isClickInside = fakoption.contains(event.target);
                    if (!isClickInside) {
                        fakoption.style.display = 'none';
                    }
                }
            });
        });
    }

    setupFakeOptions() {
        this.fakeOptionsSelector?.forEach(fakeOption => {
            const buttons = fakeOption.querySelectorAll("button");
            buttons.forEach(button => {
                button.addEventListener('click', (e) => this.handleFakeOptionClick(e, buttons));
            });
        });
    }

    handleFakeOptionClick(e, buttons) {
        const dataOption = e.currentTarget.dataset.option;
        const getAttribute = e.currentTarget.parentElement.dataset.select;
        const closestSelect = this.bandCupSelectors.querySelector(`#${getAttribute}`);
        closestSelect.value = dataOption;
        closestSelect.classList.toggle('sold-out-option', e.currentTarget.classList.contains('sold-out-option'));
        buttons.forEach(button => button.setAttribute('aria-selected', false));
        e.currentTarget.setAttribute('aria-selected', true);
        closestSelect.dispatchEvent(new Event('change', { 'bubbles': true }));
        if (e.currentTarget.parentElement.classList.contains("desktop")) {
            e.currentTarget.parentElement.style.display = 'none';
        }
    }

    initMarkupObject() {
        const markupObject = this.bandCupSelectors?.dataset?.variantObj || [];
        this.soldOutVariant = this.bandCupSelectors?.dataset?.soldOutVariants;
        
        if (markupObject && markupObject.length) {
            this.variantObj = JSON.parse(markupObject);
            this.mergedBandCupArray = this.mergeBands(this.variantObj);
            this.bandDropdown && this.bandDropdown.addEventListener('change', () => {
                const bandValue = this.bandDropdown.value;
                this.populateCupOptions(bandValue);
                this.bandCupSizeChange();
            });

            this.cupDropdown && this.cupDropdown.addEventListener('change', (e) => {
                this.bandCupSizeChange();
                if( e.currentTarget.textContent !== window.themeVariables.strings.selectCup){
                    if (e.currentTarget.classList.contains('sold-out-option')) {
                        this.updateElements(true, window.themeVariables.strings.soldOutButton);
                        this.cupDropdown.disabled = false;
                    }else{
                        this.updateElements(false, window.themeVariables.strings.addToCartButton, true);
                    }
                 }
            });

            this.populateCupOptions(this.bandDropdown.value);
        }
    }

    mergeBands(bandCupArray) {
        const merged = {};

        bandCupArray?.forEach(entry => {
            const band = Object.keys(entry)[0];
            const cups = entry[band];

            if (!merged[band]) {
                merged[band] = new Set(cups);
            } else {
                cups.forEach(cup => merged[band].add(cup));
            }
        });

        return Object.keys(merged).map(band => ({ [band]: Array.from(merged[band]) }));
    }

    updateElements(disable, buttonText, displayCheckout) {
        this.cupDropdown.disabled = disable;
        this.addToCart.disabled = disable;
        this.addToCart.innerHTML = buttonText;

        checkElement("button[data-testid='Checkout-button']").then((element) => {
            if(element){
                const container = element.closest('.shopify-payment-button')
                const displayStyle = element.style.display === "none" ? "block" : "none";
                element.style.display = displayStyle;
                container.style.display = displayStyle; 
             }  
        });
    }

    populateCupOptions(bandValue) {
        this.cupDropdown.innerHTML = '';
        const cups = this.mergedBandCupArray.find(item => item.hasOwnProperty(bandValue));
        const cupsArray = [];

        if (cups) {

            let isFirstIteration = true;

            cups[bandValue]?.forEach(cup => {

                if (isFirstIteration) {
                    const firstOption = document.createElement('option');
                    firstOption.value = "";
                    firstOption.textContent = window.themeVariables.strings.selectCup;
                    this.cupDropdown.appendChild(firstOption);
                    isFirstIteration = false;
                }

                const option = document.createElement('option');
                option.value = cup;
                option.textContent = cup;
                this.cupDropdown.appendChild(option);
                cupsArray.push(option.textContent);
            });

            const buttons = this.bandCupSelectors.querySelectorAll(`.fake-options--${this.cupDropdown.id} button`);
            buttons.forEach(button => {
                if (cupsArray.includes(button.dataset.option)) {
                    button.disabled = false;
                    button.setAttribute('aria-selected', button.dataset.option === this.cupDropdown.value ? 'true' : 'false');
                    const currentSize = `${bandValue}${button.dataset.option}`
                    const soldOutSpan = button.querySelector('.variant-picker__dropdown-sold-out-label');
                    soldOutSpan.style.display = this.soldOutVariant.includes(currentSize) ? 'block' : 'none';
                    button.classList.toggle('sold-out-option', this.soldOutVariant.includes(currentSize));
                    button.style.display = 'flex';
                } else {
                    button.disabled = true;
                    button.setAttribute('aria-selected', 'false');
                    button.style.display = 'none';
                }
            });

            this.cupDropdown.disabled = false;
        } else {
            const option = document.createElement('option');
            option.value = "";
            option.textContent = window.themeVariables.strings.selectCup;
            this.cupDropdown.appendChild(option);
            this.updateElements(true, window.themeVariables.strings.chooseOptions, false);
        }
    }

    bandCupSizeChange() {
        const bandValue = this.bandDropdown.value;
        const cupValue = this.cupDropdown.value;
        const bandCupCombined = bandValue + cupValue;

        if (this.sizeSelector.hasAttribute('is-dropdown')) {
            this.sizeSelector.querySelectorAll('button[role="option"]').forEach(button => {
                const buttonValue = button.getAttribute('value');
                if (bandCupCombined == buttonValue) {
                    button.dispatchEvent(new Event("click", { bubbles: true }));
                }
            });
        } else {
            this.sizeSelector.querySelectorAll('input[name^="option"]').forEach(option => {
                if (bandCupCombined == option.value) {
                    option.checked = true;
                    option.dispatchEvent(new Event("change", { bubbles: true }));
                }
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const element = document.querySelector("[data-option-selector][is-size][not-processed]"); 
    if (element) { 
        new BandCupSelector("[data-option-selector][is-size][not-processed]", "#band-cup-size-selectors", "buy-buttons");
        element.removeAttribute('not-processed'); 
    } 
        
});

// Handle quick add to cart button on Nosto Collection
const observeQuickAddButtons = () => {
    const observer = new MutationObserver(() => {
        document.querySelectorAll('.product-card__quick-add-button:not([data-observed])')
            .forEach((button) => {
                button.setAttribute('data-observed', 'true');
                button.addEventListener('click', handleQuickAddClick);
            });
    });

    observer.observe(document.body, { childList: true, subtree: true });
};

const waitForElement = (selector) => {
    return new Promise((resolve) => {
        const element = document.querySelector(selector);
        if (element) return resolve(element);

        const observer = new MutationObserver(() => {
            const element = document.querySelector(selector);
            if (element) {
                observer.disconnect();
                resolve(element);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    });
};

const handleQuickAddClick = async () => {
    // Capture filtered sizes from URL
    const urlParams = new URLSearchParams(window.location.search);
    const filterKeys = ['filter.v.option.size', 'filter.v.option.taille', 'filter.v.m.custom.size_uk', 'filter.v.m.custom.size_us', 'filter.v.m.custom.size_eu', 'filter.v.m.custom.size_fr'];
    const sizes = [];
    
    filterKeys.forEach(key => sizes.push(...urlParams.getAll(key)));
    if (sizes.length) window._qbSizes = sizes;
    
    await waitForElement('[data-option-selector][is-size][not-processed]');
    new BandCupSelector("[data-option-selector][is-size][not-processed]", "#band-cup-size-selectors", "buy-buttons");
};

const assignSelectorsInPDP = () => {
    observeQuickAddButtons();
};

assignSelectorsInPDP();



// Handle quick add to cart button on Collection page
const quickAddToCart = document.querySelectorAll('.product-card__quick-add-button');
const checkElement = async selector => {
    while (document.querySelector(selector) === null) {
        await new Promise(resolve => requestAnimationFrame(resolve))
    }
    return document.querySelector(selector);
};
quickAddToCart?.forEach(button => {
    button.addEventListener('click', () => {
        checkElement('.quick-buy-modal__content').then(() => {         
            new BandCupSelector("[data-option-selector][is-size][not-processed]'", "#band-cup-size-selectors", "buy-buttons");
        });
    });
})
